import { createAction } from 'redux-actions'
import { FetchService } from 'src/helpers/fetch/fetchService'
import { openApi } from 'src/utils/path'

const fetchService = new FetchService(openApi)

export interface IFetchMsgListPayload {
    status: number // 0 未读,1 已读 2 已删除
    page?: number
    pageSize?: number
}
export interface IFetchMsgListResponse {
    id: number
    type: number // 消息类型 1财务信息；2审核系统；3悠易公告；4平台升级；
    templateId?: number
    creativeId?: number
    advertId?: number
    content: string
    ctime: string
}

export interface IUpdateMsgStatusPayload {
    userId: number // 广告主id 
    msgid: number
    status: number
}

export const  RECEIVE_MSG_LIST = 'RECEIVE_MSG_LIST'

const receiveMsgList = createAction(RECEIVE_MSG_LIST)

// 获取消息列表
export const fetchMsgList = (payload: IFetchMsgListPayload) => async (dispatch) => {
    try {
        const msgList = ['msg', 'msgRead']
        const response = await fetchService.get<IFetchMsgListResponse>('v3/message/list', payload)

        dispatch(receiveMsgList({type: msgList[payload.status], data: response}))
    } catch (e) {
        fetchService.exceptionMessage(e)
    }
}

// 修改消息状态
export const updateMsgStatus = (payload: IUpdateMsgStatusPayload) => async (dispatch) => {
    try {
        await fetchService.get('v3/message/update', payload)
    } catch (e) {
        fetchService.exceptionMessage(e)
    }
}

export interface BatchIUpdateMsgStatusPayload {
    userId: number // 广告主id 
    type: number
    status: number
}

// 全部已读
export const allUpdateMsgStatus = (payload: BatchIUpdateMsgStatusPayload) => async (dispatch) => {
    try {
        await fetchService.get('v3/message/allupdate', payload)
    } catch (e) {
        fetchService.exceptionMessage(e)
    }
}